

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const SUBMITREVIEWEREVALUATION= createAsyncThunk(
  "submitReviewerEvaluation/submitReviewerEvaluation",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const submitReviewerEvaluationSlice = createSlice({
  name: "submitReviewerEvaluationSlice",
  initialState: {
    submitReviewerEvaluation: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfsubmitReviewerEvaluation: (state) => {
        state.submitReviewerEvaluation.loading = false
        state.submitReviewerEvaluation.error = false
        state.submitReviewerEvaluation.data = []
        state.submitReviewerEvaluation.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(SUBMITREVIEWEREVALUATION.fulfilled, (state, action) => {
      state.submitReviewerEvaluation = {
        ...state.submitReviewerEvaluation,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SUBMITREVIEWEREVALUATION.pending, (state, action) => {
      state.submitReviewerEvaluation = {
        ...state.submitReviewerEvaluation,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SUBMITREVIEWEREVALUATION.rejected, (state, action) => {
      state.submitReviewerEvaluation = {
        ...state.submitReviewerEvaluation,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const submitReviewerEvaluationAction = {
    SUBMITREVIEWEREVALUATION,
};

export { submitReviewerEvaluationAction };
export default submitReviewerEvaluationSlice.reducer;
export const {setInitialStateOfsubmitReviewerEvaluation} = submitReviewerEvaluationSlice.actions
